import React__default from 'react';
import classNames from 'classnames';
import QuickFilterPillStyles from './QuickFilterPill.module.scss.js';
import Skeleton from '../skeleton/Skeleton.js';

function QuickFilterPill({ text, prefix, suffix, isMobile, className, selectedClassName, prefixClassName, suffixClassName, isSelected = false, onSelected, onDeselected, data, isLoading }) {
    const _onSelected = () => {
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(data);
    };
    const _onDeselected = () => {
        onDeselected === null || onDeselected === void 0 ? void 0 : onDeselected(data);
    };
    return (React__default.createElement("div", { className: classNames(QuickFilterPillStyles.container, isSelected && QuickFilterPillStyles.selected, isSelected && selectedClassName, isMobile ? QuickFilterPillStyles.mobile : QuickFilterPillStyles.desktop, isLoading && QuickFilterPillStyles.loading, className), onClick: isSelected ? _onDeselected : _onSelected }, !isLoading ? (React__default.createElement(React__default.Fragment, null,
        " ",
        prefix && (React__default.createElement("span", { className: classNames(QuickFilterPillStyles.prefix, prefixClassName) }, prefix)),
        text && React__default.createElement("span", { className: "quickFilterPill__text" }, text),
        suffix && (React__default.createElement("span", { className: classNames(QuickFilterPillStyles.suffix, suffixClassName) }, suffix)))) : (React__default.createElement(Skeleton, { width: "100px", type: "pill" }))));
}

export { QuickFilterPill as default };
//# sourceMappingURL=QuickFilterPill.js.map
